import { FC, FocusEvent, useRef, useState } from 'react';
import { CheckedState } from '@radix-ui/react-checkbox';
import classNames from 'classnames';

import { JabraCheckbox } from '@gn-audio/jss-components/components/JabraCheckbox/JabraCheckbox';

import { longDescriptionColor } from 'src/contexts/FormTheme/formThemes';

import { TspCheckboxProps } from '../../types/checkbox';

export const getCheckboxClassNames = (hasFocus: boolean, hasAnyError: boolean): string =>
  classNames('mr-6 shrink-0 grow-0', {
    'border-gray-700 bg-white': !hasFocus && !hasAnyError,
    'border-yellow bg-white': hasFocus,
    'border-error bg-error/20': hasAnyError,
  });

const TspCheckbox: FC<TspCheckboxProps> = (props) => {
  const { errors, field, isValid, value, tracker } = props;
  const { id, name } = field.valueField;
  const { displayLabel, richText, labelCssClass, required } = field.model;
  const [hasFocus, setHasFocus] = useState(false);
  const hasAnyError = !!errors?.length;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent;

  const checkboxRef = useRef<HTMLButtonElement>(null);

  const onChange = (isChecked: CheckedState) => {
    props.onChange(name, !!isChecked.valueOf(), isValid, []);
  };
  const onFocus = (event: FocusEvent<HTMLButtonElement>) => {
    tracker.onFocusField(field, event?.target?.value);
    setHasFocus(true);
  };
  const onBlur = (event: FocusEvent<HTMLButtonElement>) => {
    tracker.onBlurField(field, event?.target?.value);
    setHasFocus(false);
  };

  const handleDescriptionClick = () => {
    checkboxRef.current?.click();
  };

  const hasLabel = !!Label && (props.field.model.title || props.field.model.richTitle);
  const hasRichText = !!richText;

  return (
    <div className="tsp-group tsp-consent">
      <>
        {hasLabel && (
          <Label textColor={longDescriptionColor} className={`!text-base font-normal`} {...props} />
        )}
        <div className="flex items-center">
          <JabraCheckbox
            id={id}
            name={name}
            ref={checkboxRef}
            value={value}
            checked={!!value}
            required={required}
            className={getCheckboxClassNames(hasFocus, hasAnyError)}
            onCheckedChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          {!hasLabel ? (
            <label
              className={classNames('cursor-default', longDescriptionColor, labelCssClass)}
              dangerouslySetInnerHTML={{ __html: displayLabel || '' }}
              htmlFor={id}
            />
          ) : (
            <p
              className={classNames('cursor-default', longDescriptionColor, labelCssClass)}
              dangerouslySetInnerHTML={{ __html: displayLabel || '' }}
              onClick={handleDescriptionClick}
            />
          )}
          {hasRichText && <div dangerouslySetInnerHTML={{ __html: String(richText) }} />}
        </div>
        {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
      </>
    </div>
  );
};

export default TspCheckbox;
